import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminServicesService } from '../admin/admin-service/admin-services.service';
import { TalkToDoctorService } from '../api-services/talk-to-doctor.service';
import { saveAs } from 'file-saver';
import { BsModalService } from 'ngx-bootstrap/modal';
/**
 * This component used for to display appointment details.
 * Here ,if user cancel or reject appointment to refund operation 
 */
@Component({
  selector: 'app-member-appointmentid',
  templateUrl: './member-appointmentid.component.html',
  styleUrls: ['./member-appointmentid.component.css']
})
export class MemberAppointmentidComponent implements OnInit {
  app_Id;
  getInfo: any;
  @ViewChild('msg') modalRef;
  reason_text: any;
  constructor(private route: ActivatedRoute, private getAppointmentDetails: TalkToDoctorService,private modalService: BsModalService) { }

  ngOnInit(): void {
    this.app_Id = this.route.snapshot.paramMap.get('id');
    let obj = {
      appointmentId: +this.app_Id
    }
    this.getAppDetails(obj)

  };

  /**
   * This method is access to get user appointment details based on appointment id req
   * @param id This id is member appointment id
   */
  getAppDetails(id) {
    this.getAppointmentDetails.appointmentDetails(id).subscribe(res => {
      this.getInfo = res;
    }, err => {

    })
  };

 /**
  * This method is to claim the refund from cancel or reject appointment.
  * @param reason In this reason param has appointment id and reason to claim.
  */
  reqClaim(reason) {
    let obj ={
      claimStatus:'REFUND OR CREDIT_POINTS',
      appointmenId:+this.app_Id,
      reason:reason
    };
   
    this.getAppointmentDetails.reqToClaim(obj).subscribe((res:any) => {
      if(res.result){
        this.modalService.show(this.modalRef, {
          initialState: {
            message: res.message
          }
        });
        this.reason_text = ""
      }else{
        this.modalService.show(this.modalRef, {
          initialState: {
            message: res.message
          }
        });
      }

    }, err => {

    })
  }
 /**
  * This method is used to get file download which user is selected
  * @param id This id is file id 
  */
  getFileId(id) {
    this.getAppointmentDetails.downloadFile(id).subscribe(res => {
      saveAs(res, id.fileName);
    })
  };

  modalOpen(template) {
    this.modalService.show(template,
      {
        class: 'modal-dialogue-centered modal-md',
        backdrop: 'static',
        keyboard: false,
      });
  }
  modalClose() {
    this.modalService.config.initialState = "";
    this.modalService.hide();
  }

}
